import { useTranslation } from 'react-i18next';

import * as S from './style';

interface FieldProps {
	title?: string;
	error?: string;
	children: React.ReactNode;
	gap?: string;
}
const Field = ({ title, error, children, gap = '0.4rem' }: FieldProps) => {
	const { t } = useTranslation();

	return (
		<S.Container gap={gap} error={!!error}>
			{title && <S.Label>{t(title)}</S.Label>}

			{children}
			{error && <S.ErrorMsg>{t(error)}</S.ErrorMsg>}
		</S.Container>
	);
};
export default Field;
